import axios, { AxiosError } from 'axios';
import { API_AUTH_LOGIN, API_AUTH_REFRESH } from "./api.urls";
import { LOGIN } from '../../common/routes'
import { LS_USER, SS_TOKEN } from '../../common/constants/storages';


const api = axios.create({
    headers: {
        'content-Type': 'application/json',//; charset=utf-8
        'content-Encoding': 'identity'
    },
    baseURL: process.env.REACT_APP_API_ENDPOINT
})

api.interceptors.request.use(
    (config) => {
        sessionStorage.getItem(SS_TOKEN);
        const token = sessionStorage.getItem(SS_TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if ((config.url?.endsWith(API_AUTH_LOGIN) || config.url?.endsWith(API_AUTH_REFRESH)) && config.method === 'post') {
            config.withCredentials = true;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
)

api.interceptors.response.use(response => response,
    async (error: AxiosError) => {
        console.log('API error status', error.response?.status);
        if (error.response?.status === 400) {
            return Promise.reject(error);
        }
        if (error.response?.status === 404) {
            return Promise.reject(error);
        }
        if (error.response?.status === 429) {
            return Promise.reject(error);
        }
        if (error.response?.status === 401 ) {
            const userId = localStorage.getItem(LS_USER);
            if (!userId || userId === "0") {
                window.location.href = LOGIN;
                return Promise.reject(error);
            }
            const refreshResponse = await api.post(API_AUTH_REFRESH, { userId });
            if (refreshResponse.status === 200) {
                let token = refreshResponse.data;
                sessionStorage.setItem(SS_TOKEN, token);
                error.config.headers['Authorization'] = `Bearer ${token}`;
                if (token) { // ������ �������
                    return api(error.config);
                }
            }
            window.location.href = LOGIN;
            return Promise.reject(error);
        }
    }
);

const apiError = async (error: AxiosError) => {
    if(!error.response) {
			return;
    }
    return error.response.data;
}

export { api, apiError };
export default api;
